import React, {useCallback, useEffect, useState, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import ModalPage from "../ModalPage";
import {Col, Row} from 'react-bootstrap';
import {convertSecondToTimeLabel, formatToLocalDate} from '../../common/utils/date_utils'
import {createMarkup} from '../../common/utils/dom_utils'
//import {getSessionInfo, getSessionRecording} from '../../common/utils/Fake_data'
import {getSessionInfo, getSessionRecording} from '../../common/BackendConnections'
import {SceneSessionChartComponent} from './SceneSessionChart'
import LoadingComponent from '../LoadingComponent'

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

import './SessionInfoComponent.css';
import NavigationHeader from "../Layout/NavigationHeader";

// -----------------------------------
const handleDragStart = (e) => e.preventDefault(); // prevent dragging cursor

// -----------------------------------------------------------------------------
function SessionInfoComponent(props) {
  const navigate = useNavigate();
  const imageCarouselRef = useRef();

  const [isLoading, setIsLoading] = useState(true);
  const [sessionInfo, setSessionInfo] = useState(undefined);
  const [sessionRecording, setSessionRecording] = useState(undefined);
  const [sessionDuration, setSessionDuration] = useState(undefined);

  const [modalHeatmapViewData, setModalHeatmapViewData] = useState({visibility: false, img_src: null, time: 0.0});

  const {sessionId} = props

  const retrieveSessionInfo = useCallback( () => {
    setIsLoading(true);
    getSessionRecording(sessionId).then((response) => {
      if (response.data.time_series && response.data.time_series.ppg.t && response.data.time_series.ppg.t.length > 0) {
        setSessionRecording(response.data);
        setSessionDuration(
          Math.round(response.data.time_series.ppg.t[response.data.time_series.ppg.t.length-1]
                      -response.data.time_series.ppg.t[0]));
        setIsLoading(false);
      }
    }).catch(function(err) {
      console.error('Failed to retrieve session recording\n' + err);
      setIsLoading(false);
    });

    getSessionInfo(sessionId).then((response) => {
      setSessionInfo(response.data);
    }).catch(function(err) { console.error('Failed to retrieve session info\n' + err); })
  }, [sessionId]);

  useEffect(() => {
    retrieveSessionInfo();
  }, [retrieveSessionInfo]);

  useEffect(() => {
    // This call is used to fix a problem with the carousel controls which may not be usable at first because of the dynamic image size calculation.
    setTimeout(() => {
      update_carousel();
    }, 2000);
  }, []);

  const update_carousel = () => {
    if (imageCarouselRef.current) {
      imageCarouselRef.current._updateComponent();
    }
  }

  const handleBackButtonClick = (event) => {
    event.preventDefault();
    navigate("/sessions/");
  };

  function handle_heatmap_image_click(p_img_src, p_time) {
    setModalHeatmapViewData({visibility: true, img_src: p_img_src, time: p_time});
  }
  function handle_modal_heatmap_view_closing() {
    setModalHeatmapViewData({visibility: false, img_src: null, time: 0.0});
  }

  // ---------------------------------------

  function get_start_time(from_sessionInfo, from_sessionRecordingData) {
    if (from_sessionInfo?.start_datetime) {
      let date_time = new Date(sessionInfo.start_datetime);
      return date_time.valueOf()  // Number of millisecond since epoch
    } else if (from_sessionRecordingData.time_series.ppg?.t) {
      return from_sessionRecordingData.time_series.ppg.t[0]
    } else if (from_sessionRecordingData.time_series.ppg?.t) {
      return from_sessionRecordingData.time_series.ppg.t[0]
    } else if (from_sessionRecordingData.time_series.ppg?.t) {
      return from_sessionRecordingData.time_series.ppg.t[0]
    } else if (from_sessionRecordingData.time_series.ppg?.t) {
      return from_sessionRecordingData.time_series.ppg.t[0]
    } else {
      return null;
    }
  }

  function add_ppg_dataset(to_chartDatasets, from_sessionRecordingData) {
    // Requires that from_sessionRecordingData.markers is an object

    let dataset = {
      title: "ppg",
      data: []
    };
    /*// Convert datetime in seconds
    let tmpDate = new Date(sessionRecordingData.time_series.ppg.data[0].x)
    let startTime = tmpDate.getTime();
    for (let value of sessionRecordingData.time_series.ppg.data) {
      value.x = new Date(value.x).getTime() - startTime; // Conversion only required if x is a Date
      dataset.data.push([value.x, value.y]);
    }*/
    let tMin=1E12, tMax=-1E12, vMin=1E12, vMax=-1E12
    let idx = 0;
    const t_0 = from_sessionRecordingData.time_series.ppg.t[0]
    for (let time_value of from_sessionRecordingData.time_series.ppg.t) {
      let value = from_sessionRecordingData.time_series.ppg.v[idx];
      const t = (time_value - t_0) * 1000;  // Chart component expects ms
      dataset.data.push([t, value]);

      tMin = (t < tMin) ? t : tMin;
      tMax = (t > tMax) ? t : tMax;
      vMin = (value < vMin) ? value : vMin;
      vMax = (value > vMax) ? value : vMax;

      idx++;
    }

    to_chartDatasets.push(dataset)
    return {tMin: tMin, tMax: tMax, vMin: vMin, vMax: vMax}
  }

  function add_marker_datasets(to_chartDatasets, from_sessionRecordingData) {
    // Requires that from_sessionRecordingData.markers is an object
    let markers_dataset = {
      title: "Markers",
      data: []
    };
    let labels_dataset = {
      title: "Labels",
      data: []
    };

    let idx = 0;
    for (let value of from_sessionRecordingData.markers.t) {
      // let milliseconds_value = new Date(value).getTime() - startTime; // Conversion only required if x is a Date
      const milliseconds_value = value * 1000; // Convert from seconds to milliseconds

      if (from_sessionRecordingData.markers.type[idx] === "obs") {
        markers_dataset.data.push([milliseconds_value, 93]);  // Y value standardized in range [0, 100]
        sessionNoteCount++;

        let elem = <div
          key={'mk_note' + idx}>{convertSecondToTimeLabel(value)} : {from_sessionRecordingData.markers.note[idx]}</div>
        sessionNotesElements.push(elem);
      } else if (from_sessionRecordingData.markers.type[idx] === "scene_label") {
        labels_dataset.data.push([milliseconds_value, 100, from_sessionRecordingData.markers.note[idx]]);
      } else {
        console.warn("Unknown session marker type: ", from_sessionRecordingData.markers.type[idx]);
      }
      idx++;
    }
    to_chartDatasets.push(markers_dataset);
    to_chartDatasets.push(labels_dataset);
  }

  function add_scene_images_dataset(to_chartDatasets, from_sessionRecordingData) {
    // Requires that from_sessionRecordingData.scene_images is an object

    const marker_y_value = 5;
    let images_dataset = {
      title: "Image_markers",
      data: []
    };

    let idx = 0;
    for (let value of from_sessionRecordingData.scene_images.t) {
      //let xValue = new Date(value).getTime() - startTime; // Conversion only required if x is a Date
      images_dataset.data.push([value * 1000, marker_y_value, from_sessionRecordingData.scene_images.img[idx]]);
      idx++;
    }
    to_chartDatasets.push(images_dataset);
  }

  function add_eye_tracking_dataset(to_heatmap_image_gallery_items, from_sessionRecordingData) {
    // Requires that from_sessionRecordingData.eye_tracking is an object

    if (from_sessionRecordingData.eye_tracking.img.length !== from_sessionRecordingData.eye_tracking.t.length) {
      console.error("Mismatch in eye-tracking records");
      return
    }

    let idx = 0;
    for (let value of from_sessionRecordingData.eye_tracking.img) {
      const seconds = sessionRecordingData.eye_tracking.t[idx];
      to_heatmap_image_gallery_items.push(
        <div className={'heatmap_gallery_item'} key={idx}>
          <img src={value} onDragStart={handleDragStart}
               alt={"Scene eye-tracking heatmap"}
               height={'260px'} width={'350px'}
               onClick={() => handle_heatmap_image_click(value, seconds)}/>
          <p>Time: {convertSecondToTimeLabel(seconds)}</p>
        </div>
      );
      idx += 1;
    }
  }

  // ---------------------------------------

  const sessionRecordingData = sessionRecording;

  let heatmap_image_gallery_items = [];
  let chartDatasets = [];
  let sessionNoteCount = 0;
  let sessionNotesElements = [];
  let xMin=0, xMax= 30000, yMin=0, yMax=200
  if (sessionRecordingData &&
    sessionRecordingData.time_series &&
    sessionRecordingData.time_series.ppg &&
    sessionRecordingData.time_series.ppg.t.length > 0) {

    const bounds = add_ppg_dataset(chartDatasets, sessionRecordingData);
    const minRangeX = 20000; // ms
    xMin = bounds.tMin
    xMax = ((bounds.tMax - bounds.tMin) < minRangeX) ? xMin + minRangeX : bounds.tMax
    yMin = bounds.vMin
    yMax = bounds.vMax
    const spanY = yMax - yMin

    if (sessionRecordingData.markers) {
      add_marker_datasets(chartDatasets, sessionRecordingData)
    }

    if (sessionRecordingData.scene_images) {
      add_scene_images_dataset(chartDatasets, sessionRecordingData)
    }

    if (sessionRecordingData.eye_tracking) {
      add_eye_tracking_dataset(heatmap_image_gallery_items, sessionRecordingData)
    }
  }
  const hasTimeSeries = (chartDatasets.length > 0);

  const navPath = "Patient Sessions > Session Summary ";
  let datetime_label = "";
  let time_span_label = ""
  if (sessionInfo) {
    let sessionDateTime = new Date(sessionInfo.datetime_iso8601);
    datetime_label = formatToLocalDate(sessionDateTime);
    time_span_label = sessionDateTime.toLocaleTimeString();

    if (hasTimeSeries) {
      let sessionEndDateTime = new Date(sessionDateTime.getTime() + sessionDuration * 1000);
      time_span_label += " - " + sessionEndDateTime.toLocaleTimeString();
    }
  }

  // ----------------------------------------------------------------------------
  return (
    <div className={"page_content"}>
      <NavigationHeader />

      {sessionInfo ?
        <div>
          <span className={"fainted_text mt-3"}>{navPath}</span>
          <h1 className={"mt-0"}>Session Summary #{sessionInfo?.session_short_id}</h1>

          <Row style={{marginTop:"2em"}}>
            <Col xs={5} className="thin_content_box">
            <div>
              <h2>General</h2>
              <div>Game: {sessionInfo?.scene_name}</div>
              <div>Patient: {sessionInfo?.patient_name}</div>
              <div>Date: {datetime_label}</div>
              <div>Time: {time_span_label}</div>
              <div>Device: {sessionInfo?.device_name}</div>
            </div>
            </Col>
            <Col xs={{ span: 5, offset: 2 }}  className="thin_content_box">
              <div id={"sessionOverview"}>
                <h2>Session Overview</h2>
                {hasTimeSeries &&
                  <div>Duration: {sessionDuration} sec.</div>
                }
                <div dangerouslySetInnerHTML={createMarkup(sessionInfo?.info)}/>
              </div>
            </Col>
          </Row>

          <Row style={{marginTop:"2em"}}>
            <Col xs={12} className="thin_content_box">
              <div>
                <h2>Timeline of Session</h2>
                <div className="chart">
                  <div style={{justifyContent: "space-evenly", display: "flex", flexDirection: "column",
                    marginTop: '1em', marginBottom: '2em', marginRight: '.5em'}}>
                    <div style={{flexGrow: "1", marginTop: '0em'}}>Markers</div>
                    {/*<div style={{flexGrow: "1", marginTop: '1em'}}>High Stress</div>*/}
                  </div>
                  <SceneSessionChartComponent datasets={chartDatasets} title={"Session"} xAxisTitle={"Time"} yAxisTitle={"Beats Per Minute"} xMin={xMin} xMax={xMax} yMin={yMin} yMax={yMax}/>
                </div>
              </div>
            </Col>
          </Row>

          <Row style={{marginTop:"2em"}}>
            <Col xs={12} className="thin_content_box">
              <div>
                <h2>Eye-tracking</h2>
                <AliceCarousel mouseTracking items={heatmap_image_gallery_items} autoWidth={true} ref={imageCarouselRef}/>
              </div>
            </Col>
          </Row>

          <Row style={{marginTop:"2em"}}>
            <Col xs={12} className="thin_content_box">
              <div>
                <h2>Notes</h2>
                <div className={"mt-3"}
                     style={{textAlign: "justify"}}
                     dangerouslySetInnerHTML={createMarkup(sessionInfo?.note)}/>
                {(sessionNoteCount > 0) && <br/>}
                {sessionNotesElements}
              </div>
            </Col>
          </Row>

          <Row style={{marginTop:"2em"}}>
            <Col>
              <button className={"app-button-style2"}
                      onClick={handleBackButtonClick}>Back to Sessions</button>
            </Col>
          </Row>
        </div>
        :
        isLoading ?
          <LoadingComponent/>
          :
          <div>
            <h1 className={"mt-3"}>Session not found</h1>
            <button className={"app-button-style2 active"}
                    onClick={handleBackButtonClick}>Back to Sessions</button>
          </div>
      }

      {modalHeatmapViewData.visibility &&
        <ModalPage show={modalHeatmapViewData.visibility} onHide={handle_modal_heatmap_view_closing}
                   windowTitle={"Eye-tracking heatmap at " + convertSecondToTimeLabel(modalHeatmapViewData.time)}
                   className={"modal_heatmap_image_view"}
                   body_component={
          <div>
            <img src={modalHeatmapViewData.img_src} onDragStart={handleDragStart} alt={"Scene eye-tracking heatmap"} className={'fullscreen_image_view_style'}/>
          </div>
                     }
                   /*footer_component={
                     <>
                       <button className={"add-session-button-style"} onClick={handle_modal_heatmap_view_closing}>
                         Close
                       </button>
                     </>
                   }*/
        />
      }
    </div>
  );
}

export default SessionInfoComponent;
